export default "__VITE_ASSET__f6f95407__"